import React from "react";
import { useSettings, useLang } from "../lib/providers";

export default function BetaBanner() {
  const { settings } = useSettings();
  const { lang } = useLang();
  if (!settings?.beta_mode_enabled) return null;
  const msg = lang === "ar"
    ? (settings.beta_mode_message_ar || settings.beta_mode_message_fr)
    : (settings.beta_mode_message_fr || settings.beta_mode_message_ar);
  if (!msg) return null;
  return (
    <div className="w-full bg-clay text-black text-center text-xs font-bold uppercase tracking-widest px-4 py-2 border-b border-black/20" data-testid="beta-banner">
      {msg}
    </div>
  );
}
